import { isNotNilOrEmpty } from '@pcty/utils';
/**
 * Formats a value as a minutes
 *
 * @param {number} value The value to format
 * @returns {string} The formatted string
 */
export var minutesFormatter = function (value) {
    return isNotNilOrEmpty(value) ? "".concat(value, " ").concat(value === 1 ? 'min' : 'mins') : '';
};
